import { Pic, Btn, ET } from "./SiteParts";

export const BLOCKS = ["process", "stats", "team", "pricing", "menu", "portfolio", "timeline", "partners", "comparison", "benefits", "locations", "schedule", "offer", "newsletter", "values"];

const H = ({ t, children, cls = "text-lg", path }) => <ET as="h3" path={path} value={children} className={`block ${cls}`} style={{ fontFamily: t.fonts.heading, color: t.palette.primary }} />;
const P = ({ path, value, cls }) => <ET as="p" multi path={path} value={value} className={`block ${cls}`} />;

function Steps({ items, t, mobile, timeline, sid }) {
  const pal = t.palette;
  return (
    <ol className={`mt-8 grid gap-6 ${mobile || timeline ? "" : "grid-cols-4"} ${timeline ? "border-l-2 pl-6" : ""}`} style={{ borderColor: `${pal.accent}66` }}>
      {items.map((it, i) => (
        <li key={i} className="relative">
          {timeline && <span className="absolute -left-[31px] top-1 w-3 h-3 rounded-full" style={{ background: pal.accent }} />}
          <p className="text-xs font-semibold tracking-widest" style={{ color: pal.accent }}>{timeline ? it.meta || "" : `STEP ${i + 1}`}</p>
          <H t={t} path={["s", sid, i, "title"]}>{it.title}</H><P path={["s", sid, i, "text"]} value={it.text} cls="text-sm mt-1 opacity-75" />
        </li>))}
    </ol>);
}

function PriceList({ items, t, r, mobile, tiers }) {
  const pal = t.palette;
  if (tiers) return <div className={`mt-8 grid gap-4 ${mobile ? "" : "grid-cols-3"}`}>{items.map((it, i) => (
    <div key={i} className="p-6 border" style={{ borderRadius: r, background: i === 1 && !mobile ? pal.primary : pal.surface, color: i === 1 && !mobile ? "#fff" : pal.text, borderColor: `${pal.muted}33` }}>
      <p className="font-semibold">{it.title}</p><p className="text-3xl mt-2" style={{ fontFamily: t.fonts.heading }}>{it.meta || it.price || "[Price]"}</p><p className="text-sm mt-3 opacity-80">{it.text}</p></div>))}</div>;
  return <div className="mt-8 max-w-3xl space-y-4">{items.map((it, i) => (
    <div key={i}><div className="flex items-baseline gap-3"><span className="font-semibold" style={{ color: pal.primary }}>{it.title}</span><span className="flex-1 border-b border-dotted" style={{ borderColor: `${pal.muted}66` }} /><span className="font-semibold text-sm" style={{ color: pal.accent }}>{it.meta || it.price || ""}</span></div>
      {it.text && <p className="text-xs opacity-70 mt-0.5">{it.text}</p>}</div>))}</div>;
}

function People({ items, t, r, mobile, logos }) {
  const pal = t.palette;
  if (logos) return <div className="mt-8 flex flex-wrap gap-3">{items.map((it, i) => <span key={i} className="px-5 py-3 text-sm font-semibold border" style={{ borderRadius: r, borderColor: `${pal.muted}33`, color: pal.muted }}>{it.title}</span>)}</div>;
  return <div className={`mt-8 grid gap-5 ${mobile ? "grid-cols-2" : "grid-cols-4"}`}>{items.map((it, i) => (
    <div key={i} className="text-center"><div className="mx-auto w-20 h-20 rounded-full flex items-center justify-center text-xl" style={{ background: `${pal.primary}14`, color: pal.primary, fontFamily: t.fonts.heading }}>{(it.title || "?").replace(/[[\]]/g, "").slice(0, 1)}</div>
      <p className="mt-3 font-semibold text-sm">{it.title}</p><p className="text-xs opacity-70">{it.text}</p></div>))}</div>;
}

function Compare({ items, t, r }) {
  const pal = t.palette;
  return (
    <div className="mt-8 overflow-hidden border text-sm" style={{ borderRadius: r, borderColor: `${pal.muted}33` }}>
      {items.map((it, i) => (
        <div key={i} className="grid grid-cols-3 gap-3 px-4 py-3" style={{ background: i % 2 ? pal.surface : "transparent" }}>
          <span className="font-semibold">{it.title}</span><span style={{ color: pal.primary }}>{it.text}</span><span className="opacity-60">{it.meta || "—"}</span>
        </div>))}
    </div>);
}

function Stats({ items, t, mobile }) {
  return <div className={`mt-8 grid gap-6 ${mobile ? "grid-cols-2" : "grid-cols-4"}`}>{items.map((it, i) => (
    <div key={i}><p className="text-4xl" style={{ fontFamily: t.fonts.heading, color: t.palette.accent }}>{it.title}</p><p className="text-sm mt-1 opacity-75">{it.text}</p></div>))}</div>;
}

function Offer({ s, t, r, href }) {
  const pal = t.palette, it = s.items?.[0] || {};
  return (
    <div className="mt-8 p-8 flex flex-wrap items-center justify-between gap-4" style={{ background: `${pal.accent}22`, border: `2px dashed ${pal.accent}`, borderRadius: r }}>
      <div><p className="text-3xl" style={{ fontFamily: t.fonts.heading, color: pal.primary }}>{it.meta || it.title || "[Offer]"}</p><p className="text-sm opacity-80 mt-1">{it.text}</p></div>
      <Btn t={t} href={href}>{it.title && it.meta ? it.title : "Claim offer"}</Btn>
    </div>);
}

function Newsletter({ t, r, href }) {
  const pal = t.palette;
  return (
    <div className="mt-8 flex max-w-xl gap-2">
      <div className="flex-1 h-11 px-4 flex items-center text-xs opacity-60 border" style={{ borderRadius: r, borderColor: `${pal.muted}44`, background: pal.surface }}>Your email address</div>
      <Btn t={t} href={href}>Subscribe</Btn>
    </div>);
}

function Listing({ items, t, r, mobile, pics, sid }) {
  const pal = t.palette;
  return <div className={`mt-8 grid gap-5 items-start ${mobile ? "" : pics ? "grid-cols-3" : "grid-cols-2"}`}>{items.map((it, i) => (
    <div key={i} className={pics ? "" : "p-5 border-l-4"} style={pics ? {} : { borderColor: pal.accent, background: pal.surface, borderRadius: r }}>
      {pics && <Pic id={it.image_asset_id} alt={it.title} r={r} />}
      {!pics && it.image_asset_id && <div className="mb-3"><Pic id={it.image_asset_id} alt={it.title} r={r} /></div>}
      <div className={pics ? "mt-3" : ""}><H t={t} path={["s", sid, i, "title"]}>{it.title}</H>{it.meta && <p className="text-xs font-semibold mt-1" style={{ color: pal.accent }}>{it.meta}</p>}<P path={["s", sid, i, "text"]} value={it.text} cls="text-sm mt-1 opacity-75" /></div>
    </div>))}</div>;
}

export function Block({ s, t, r, mobile, href }) {
  const items = s.items || [], p = { items, t, r, mobile, sid: s.id };
  switch (s.type) {
    case "process": return <Steps {...p} />;
    case "timeline": return <Steps {...p} timeline />;
    case "pricing": return <PriceList {...p} tiers />;
    case "menu": return <PriceList {...p} />;
    case "team": return <People {...p} />;
    case "partners": return <People {...p} logos />;
    case "comparison": return <Compare {...p} />;
    case "stats": return <Stats {...p} />;
    case "offer": return <Offer s={s} t={t} r={r} href={href} />;
    case "newsletter": return <Newsletter t={t} r={r} href={href} />;
    case "portfolio": return <Listing {...p} pics />;
    default: return <Listing {...p} />;
  }
}
